export class EnvService {

  production:boolean = false;
  apiBaseUrl:string = 'http://localhost/miiar/api';
  baseUrl:string = 'http://localhost/miiar';

  constructor() {
  }

}